module.exports = __webpack_public_path__ + "media/widget/DiscontinedGoals-a78cb1fb.png";